import { Link } from 'react-router-dom'
import useBreakpoint from '../hooks/ui/useBreakpoint'
import Icon from './Icon/Icon'

const Logo = () => {
  const isSm = useBreakpoint('sm')

  return (
    <Link to='/trade'>
      {isSm ? (
        <Icon name='carbon-mobile-logo' width='32px' height='32px' />
      ) : (
        <Icon name='carbon-full-logo-2' width='140px' height='35px' />
      )}
    </Link>
  )
}

export default Logo
